// extracted by mini-css-extract-plugin
export default {"buildingInfo":"detail-auction-modal_buildingInfo__xi2Z4","auctionInfo":"detail-auction-modal_auctionInfo__-C4-V","auctionColumn":"detail-auction-modal_auctionColumn__jkTNP"};